// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2phkU","vLegacy":"SelectSecondary_vLegacy__20quZ","error":"SelectSecondary_error__2Iwm8","disabled":"SelectSecondary_disabled__QNn8Q"};